import { connect } from "react-redux";

import Button from "../base/Button";

const renderIcon = (color) => (
    <svg
        width="32"
        height="32"
        viewBox="-2 -2 36 36"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <g xmlns="http://www.w3.org/2000/svg" stroke={color}>
            <polygon points="16 4 20 4 20 0 16 0" />
            <polygon points="28 4 32 4 32 0 28 0" />
            <polygon points="0 32 4 32 4 28 0 28" />
            <polygon points="0 14 4 14 4 18 0 18" />
            <polygon points="28 32 32 32 32 28 28 28" />
            <polygon points="16 14 16 18 20 18 20 14" />
            <path d="M20,2 L28,2" />
            <path d="M30,4 L30,28" />
            <path d="M4,30 L28,30" />
            <path d="M2,28 L2,18" />
            <path d="M4,16 L16,16" />
            <path d="M18,14 L18,4" />
        </g>
    </svg>
);

const GroupButton = (props) => <Button {...props} renderIcon={renderIcon} />;

const tooltipMessage =
    "To use the Group Editor, please disable Device-to-Cloud Control Groups for the Site in Admin. " +
    "You may re-enable this feature after you have finished making changes.";

const mapStateToProps = ({ map }) => {
    const disabled = map.general.site?.controlGroupsJsonD2CEnabled;
    const tooltip = disabled ? tooltipMessage : null;

    return {
        disabled,
        tooltip,
    };
};

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(GroupButton);
